import { Button, Icon, Modal, NOOP, useTranslation } from '@testsigma/atoms';
import classNames from 'classnames';
import { useCallback, useContext, useState } from 'react';
import { OnboardingHeader } from './header';
import AmplitudeEventService from '@services/amplitude-event.service';
import installRecorder from '@images/install-recorder.svg';
import { SessionContext } from '@contexts/session-context';

interface ChromeExtensionInstallProps {
  show: boolean;
  onClose?: () => void;
}

export const ChromeExtensionInstallScreen: React.FC<
  ChromeExtensionInstallProps
> = ({ show, onClose }) => {
  const { t } = useTranslation();
  const { session } = useContext(SessionContext);
  const extensionDownloadUrl = session?.recorderDownloadEnabled
    ? window.location.origin + '/ui/settings/about'
    : 'https://chrome.google.com/webstore/detail/testsigma/epmomlhdjfgdobefcpocockpjihaabdp?hl=en-US';

  const [isClicked, setIsClicked] = useState(false);

  const onClickRemindMeLater = useCallback(() => {
    setIsClicked(true);
    AmplitudeEventService.onInstallExtensionAction(true, false);
    onClose();
  }, [onClose]);

  const onClickInstallExtension = useCallback(() => {
    setIsClicked(true);
    AmplitudeEventService.onInstallExtensionAction(true, true);
    onClose();
  }, [onClose]);

  return (
    <Modal
      isOpen={show}
      className={classNames('w-full h-full')}
      closeOnEscape={false}
      closeOnOutsideClick={false}>
      <OnboardingHeader />

      <div className='flex items-center justify-center mt-24 px-40 gap-x-32'>
        <div className='flex items-center justify-center'>
          <img src={installRecorder} />
        </div>

        <div className='flex flex-col max-w-[640px]'>
          <div className='text-lg font-medium text-unique-600'>
            {t('common.install.chrome.extension')}
          </div>

          <div className=' text-sm text-unique-800 mt-4'>
            {t('common.install.chrome.extension.desc')}
          </div>

          <div className=' text-sm text-unique-800 font-medium mt-4'>
            {t('common.about.recorder')}
          </div>

          <div className=' text-sm text-unique-800 mt-2'>
            {t('common.about.recorder.desc')}
          </div>

          <div className='flex mt-12 items-center justify-between'>
            <a href={extensionDownloadUrl} target='_blank' rel='noreferrer'>
              <Button onClick={onClickInstallExtension} isDisabled={isClicked}>
                <div className='flex items-center gap-x-1'>
                  <div>
                    <Icon name='download-for-offline' />
                  </div>
                  <div>{t('common.get.extension')}</div>
                </div>
              </Button>
            </a>
            <div
              className='text-sm underline text-secondary-400 font-medium cursor-pointer hover:text-secondary-600'
              onClick={isClicked ? NOOP : onClickRemindMeLater}>
              {t('common.remind_me.later')}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
